import WithDirection from '@app/settings/withDirection';
import { Tabs } from 'antd';
import AntTab from './styles/tab.style';

const WDTabs = AntTab(Tabs);

export const IsoTabPane = Tabs.TabPane;
export const IsoTabs = WithDirection(WDTabs);
